import { create } from 'zustand';
import partnerService from '../services/partnerService';

const usePartnerStore = create((set, get) => ({
  dashboard: null,
  profile: null,
  stats: null,
  team: [],
  isLoading: false,
  error: null,

  // Fetch dashboard data
  fetchDashboard: async () => {
    set({ isLoading: true });
    try {
      const data = await partnerService.getDashboard();
      set({ dashboard: data.data, isLoading: false });
      return data.data;
    } catch (error) {
      set({ isLoading: false, error: error.message });
      throw error;
    }
  },

  // Fetch profile
  fetchProfile: async () => {
    set({ isLoading: true });
    try {
      const data = await partnerService.getProfile();
      set({ profile: data.data, isLoading: false });
      return data.data;
    } catch (error) {
      set({ isLoading: false, error: error.message });
      throw error;
    }
  },

  // Update profile
  updateProfile: async (profileData) => {
    set({ isLoading: true });
    try {
      const data = await partnerService.updateProfile(profileData);
      set({ profile: data.data, isLoading: false });
      return data.data;
    } catch (error) {
      set({ isLoading: false, error: error.message });
      throw error;
    }
  },

  // Fetch stats
  fetchStats: async (period = 'month') => {
    set({ isLoading: true });
    try {
      const data = await partnerService.getStats(period);
      set({ stats: data.data, isLoading: false });
      return data.data;
    } catch (error) {
      set({ isLoading: false, error: error.message });
      throw error;
    }
  },

  // Fetch team members
  fetchTeam: async () => {
    set({ isLoading: true });
    try {
      const data = await partnerService.getTeamMembers();
      set({ team: data.data || [], isLoading: false });
      return data.data;
    } catch (error) {
      set({ isLoading: false, error: error.message });
      throw error;
    }
  },

  // Add team member
  addTeamMember: async (memberData) => {
    set({ isLoading: true });
    try {
      await partnerService.addTeamMember(memberData);
      await get().fetchTeam();
      set({ isLoading: false });
      return true;
    } catch (error) {
      set({ isLoading: false, error: error.message });
      throw error;
    }
  },

  // Remove team member
  removeTeamMember: async (userId) => {
    set({ isLoading: true });
    try {
      await partnerService.removeTeamMember(userId);
      set((state) => ({
        team: state.team.filter((m) => m._id !== userId),
        isLoading: false
      }));
      return true;
    } catch (error) {
      set({ isLoading: false, error: error.message });
      throw error;
    }
  },

  // Clear error
  clearError: () => set({ error: null }),

  // Reset state
  reset: () => set({
    dashboard: null,
    profile: null,
    stats: null,
    team: [],
    isLoading: false,
    error: null
  })
}));

export { usePartnerStore };
